"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const locale_codes_1 = __importDefault(require("locale-codes"));
const debug_1 = __importDefault(require("debug"));
const hunspell_1 = require("../hunspell");
const lunr_1 = __importDefault(require("lunr"));
require("lunr-languages/lunr.stemmer.support")(lunr_1.default);
require('lunr-languages/lunr.hu.js')(lunr_1.default);
const debug = debug_1.default('lunr-environment');
class LunrEnvironmentContext {
    constructor(details, hunspell) {
        this.details = details;
        this.hunspell = hunspell;
    }
    dispose() {
        if (this.hunspell) {
            this.hunspell.dispose();
        }
    }
}
exports.LunrEnvironmentContext = LunrEnvironmentContext;
function registerHunspellIfRequired(details) {
    if (details.useHunspell) {
        details.theLunr.Pipeline.registerFunction(details.stemmer, 'hunspell-stemmer');
    }
}
exports.registerHunspellIfRequired = registerHunspellIfRequired;
function loadIndex(serializedIndex) {
    debug('loading index');
    const index = lunr_1.default.Index.load(serializedIndex);
    debug('index loaded');
    return index;
}
exports.loadIndex = loadIndex;
function registerDefaultHunspellStemmer() {
    lunr_1.default.Pipeline.registerFunction(defaultHunspellStemmer, 'hunspell-stemmer');
}
exports.registerDefaultHunspellStemmer = registerDefaultHunspellStemmer;
function defaultHunspellStemmer(token) {
    return token;
}
function configureIndexPipeline(builder, details) {
    registerHunspellIfRequired(details);
    debug('configure-index-pipeline', details);
    if (details.plugin) {
        debug('loading plugin');
        builder.use(details.plugin);
    }
    else {
        debug('updating default environment');
        builder.pipeline.reset();
        builder.pipeline.add(details.trimmer, details.stopWordFilter, details.stemmer);
        if (builder.searchPipeline) {
            builder.searchPipeline.reset();
            builder.searchPipeline.add(details.stemmer);
        }
    }
    debug('pipeline after set', builder.pipeline);
    debug('search pipeline after set', builder.searchPipeline);
}
exports.configureIndexPipeline = configureIndexPipeline;
let LunrEnvironment = class LunrEnvironment {
    constructor(hunspellAdapter) {
        this.hunspellAdapter = hunspellAdapter;
    }
    // generateQueryString(text: string, language: string) {
    //   const environment = this.resolveLanguageEnvironment(language)
    //   const stemmedWords = text.split(' ').map((w) => environment.stemmer(new lunr.Token(w, {})))
    //   const jokeredWords = text.split(' ').map((w) => w + '*')
    //   // we search for original and stemmed too
    //   const finalQuery = `${text} ${stemmedWords.join(' ')} ${jokeredWords.join(' ')}`
    //   return finalQuery
    // }
    resolveLanguageEnvironment(language) {
        const DEFAULT_ISO639_1 = 'en';
        debug('resolveLanguageEnvironment', language);
        let loc = locale_codes_1.default.getByTag(language);
        if (!loc) {
            debug(`Invalid language code '${language}', using default '${DEFAULT_ISO639_1}'`);
            loc = locale_codes_1.default.getByTag(DEFAULT_ISO639_1);
        }
        if (!loc["iso639-1"]) {
            debug(`Locale tag '${loc.tag}' has no iso639-1 code, using default language '${DEFAULT_ISO639_1}'`);
            loc = locale_codes_1.default.getByTag(DEFAULT_ISO639_1);
            if (!loc["iso639-1"]) {
                throw new Error('Coding error: default language has no iso639-1 code.');
            }
        }
        // defaults
        let stemmer = lunr_1.default.stemmer;
        let trimmer = lunr_1.default.trimmer;
        let stopWordFilter = lunr_1.default.stopWordFilter;
        // try to find the plugin
        const iso6391LangCode = loc["iso639-1"];
        let languagePlugin = null;
        if (iso6391LangCode !== DEFAULT_ISO639_1) {
            debug(`trying to find lunr plugin for language '${loc["iso639-1"]}'`);
            languagePlugin = lunr_1.default[iso6391LangCode];
            if (languagePlugin) {
                debug(`found language plugin for language '${iso6391LangCode}'`, languagePlugin);
                stemmer = languagePlugin.stemmer || stemmer;
                trimmer = languagePlugin.trimmer || trimmer;
                stopWordFilter = languagePlugin.stopWordFilter || stopWordFilter;
            }
            else {
                debug(`language plugin not found for language '${iso6391LangCode}', using default '${DEFAULT_ISO639_1}'`);
            }
        }
        const hunspellResult = this.hunspellAdapter.resolveLanguage(language);
        debug('hunspell resolve result', hunspellResult);
        const useHunspell = hunspellResult.success;
        if (hunspellResult.success) {
            // supported by hunspell, use it
            const hunspellStemmer = this.createHunspellStemmer(hunspellResult.value);
            if (languagePlugin) {
                // set hunspellStemmer as the plugin's stemmer
                languagePlugin.stemmer = hunspellStemmer;
            }
            stemmer = hunspellStemmer;
        }
        const details = {
            plugin: languagePlugin,
            useHunspell,
            stemmer,
            trimmer,
            stopWordFilter,
            theLunr: lunr_1.default
        };
        return new LunrEnvironmentContext(details, hunspellResult.success ? hunspellResult.value : undefined);
    }
    createHunspellStemmer(hunspell) {
        return function hunspellStemmer(token) {
            debug('stemming', token.toString());
            const word = token.toString();
            const stemmed = hunspell.stem(word);
            if (stemmed.length === 0) {
                debug('no stemmed for', token.toString());
                return token;
            }
            const stemResult = stemmed.map((one) => {
                return token.clone().update(() => one);
            });
            debug('stem', word, '=>', stemResult.map(x => x.toString()));
            if (stemResult.findIndex(x => x.toString() == token.toString()) < 0) {
                // include the original token too
                return [token, ...stemResult];
            }
            return [...stemResult];
        };
    }
};
LunrEnvironment = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(hunspell_1.HunspellAdapterSymbol)),
    __metadata("design:paramtypes", [Object])
], LunrEnvironment);
exports.LunrEnvironment = LunrEnvironment;
//# sourceMappingURL=lunr-environment.js.map